<p *ngIf="loading$ | async; else itemsDisplay">
  <em>Loading...</em>
</p>
<ng-template #itemsDisplay>
  <div class="flex flex-col justify-start items-start basis-full flex-grow min-h-[400px]">
    <table mat-table [dataSource]="results$ | async" matSort (matSortChange)="onSortChange($event)" class="w-full">
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Job Type</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.type | titlecase}}</td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Created</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.created_at | amDateFormat : dateFormat }}
        </td>
      </ng-container>

      <ng-container matColumnDef="due">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Due</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.due | amDateFormat : dateFormat }}
        </td>
      </ng-container>

      <ng-container matColumnDef="user_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Assigned To</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.user_name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="customer_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Customer</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.customer_name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>ID</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="deliverable_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Source</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (element.deliverable_type === 'booking') {
          <a [routerLink]="['/bookings/view', element.deliverable_id]">{{ element.deliverable_name }}</a>
          } @else if (element.deliverable_type === 'docket') {
          <a [routerLink]="['/docket', element.deliverable_id]">{{ element.deliverable_name }}</a>
          } @else {
          {{ element.deliverable_name }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Location</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.location }}
        </td>
      </ng-container>

      <ng-container matColumnDef="resultant_completed_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Completed At</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.fulfilled_date | amDateFormat : dateFormat }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actual_completed_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Actual Completed At</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.actual_completed_at | amDateFormat : dateFormat }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="flex flex-row justify-end items-center w-full bg-white">
      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page"
        (page)="onPageChange($event)" class="w-full" [length]="total$ | async" [pageSize]="pageSize$ | async"
        [pageIndex]="pageIndex$ | async">
      </mat-paginator>
      <button mat-icon-button matTooltip="Export to Excel" (click)="excelExport()">
        <mat-icon>download</mat-icon>
      </button>
    </div>
  </div>
</ng-template>